export default "__VITE_ASSET__DRA5tS0A__"